// machineThunks.js
import { serverCall } from 'utils/serverCall';
import {
  initMachineListRequestDashBoard,
  setMachineListDashBoard,
  errorMachineListDashBoard,
  initChartRequestDashBoard,
  setChartDataDashBoard,
  errorChartDataDashBoard,
} from './action';
import apiEndpoints from 'utils/apiList';

export const fetchMachineListByCompanyId = (companyId) => {
  return async (dispatch) => {
    dispatch(initMachineListRequestDashBoard());
    if(!companyId){
      dispatch(errorChartDataDashBoard(''));
      dispatch(errorMachineListDashBoard(''));
      return;
    }
    try {
      const result = await serverCall(`${apiEndpoints.MACHINE_LIST_BY_COMPANY}/${companyId}`, 'GET', dispatch);
      if (result.success) {
        dispatch(setMachineListDashBoard(result?.data?.payload));
      } else {
        dispatch(errorMachineListDashBoard(result.message));
      }
    } catch (error) {
      dispatch(errorMachineListDashBoard(error.message));
    }
  };
};

export const fetchChartData = (data) => {
  return async (dispatch) => {
    dispatch(initChartRequestDashBoard());

    if (!data?.company_id || !data?.endDate || !data?.startDate || !data?.id) {
      dispatch(errorChartDataDashBoard(''));
      return;
    }

    try {
      const result = await serverCall(`${apiEndpoints.CHART_DATA}`, 'POST',dispatch, data);
      if (result.success) {
        dispatch(setChartDataDashBoard(result?.data?.payload));
      } else {
        // toast.error(result?.message)
        dispatch(errorChartDataDashBoard(result.message));
      }
    } catch (error) {
      dispatch(errorChartDataDashBoard(error.message));
    }
  };
};
